<ng-container>
  <div class="row">
    <div class="col-md-11 fieldset">
      <div class="card mt-2 mt-md-0">
        <div class="card-body p-0 pt-3 px-3 m-0">
          <div class="col-md fieldset">
            <div class="row">
              <app-form-group label="{{ vesselPrefix }} vessel ENI">
                <input [(ngModel)]="formBarge.eni" id="eni" maxlength="64" class="form-control" required>
              </app-form-group>
            </div>
            <div class="row">
              <app-form-group label="{{ vesselPrefix }} vessel Name">
                <input [(ngModel)]="formBarge.name" id="name" maxlength="64" class="form-control" required>
              </app-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-1 fieldset">
      <div>
        <button class="btn">
          <span class="fa fa-trash text-secondary" (click)="notifyParent()"></span>
        </button>
      </div>
    </div>
  </div>
  <br>
</ng-container>
